import {
	Flex,
	IconV2,
	LayoutBox,
	Nub,
	StyledBoxV2,
	TextButton,
	TextField,
} from '@bamboohr/fabric';
import { ReactElement, useState } from 'react';

export function LoginPassword({
	showForgotPassword = true,
	inputId = 'password',
}): ReactElement {
	const [passwordType, setPasswordType] = useState('password');
	const [passwordText, setPasswordText] = useState($.__('Show Password'));

	const updatePasswordType = () => {
		setPasswordType(passwordType === 'password' ? 'text' : 'password');
		setPasswordText(
			passwordText === $.__('Show Password')
				? $.__('Hide Password')
				: $.__('Show Password'),
		);
	};

	return (
		<LayoutBox marginBottom={showForgotPassword ? 4 : ''}>
			<div className="fab-InputWrapper">
				<TextField
					aria-label={$.__('Password')}
					data-placeholder-trigger="keydown"
					id={inputId}
					InputProps={{
						startAdornment: (
							<Nub position="start">
								<IconV2 name="key-regular" size={16} />
							</Nub>
						),
					}}
					inputProps={{
						type: passwordType,
					}}
					name="password"
					placeholder={$.__('Password')}
					width={9}
				/>
			</div>
			<StyledBoxV2 marginTop={0.5}>
				<Flex
					alignItems="center"
					justifyContent={showForgotPassword ? 'space-between' : 'flex-end'}
				>
					{showForgotPassword && (
						<button
							className="fab-TextButton fab-TextButton--muted fab-TextButton--small ffront forgot"
							type="button"
						>
							{$.__('Forgot Password?')}
						</button>
					)}
					<TextButton
						color="secondary"
						onClick={updatePasswordType}
						size="small"
						type="button"
					>
						{passwordText}
					</TextButton>
				</Flex>
			</StyledBoxV2>
		</LayoutBox>
	);
}
export default LoginPassword;
